export default "/static/media/icon-live-status.1e9b99c0.svg";